function Logo({ fontSize }) {
    return (<p id="logo" style={{ fontSize: fontSize }}><span style={{ color: "blue" }}>AI</span><span style={{ color: "grey" }}>r</span><span style={{ color: "red" }}>Control</span></p>)
}

export default Logo;